// simple performance timing utility for console debugging
// usage: window.__siftPerf.startTimer("name"), window.__siftPerf.endTimer("name"), window.__siftPerf.report()

const timers = new Map();
const completed = [];

function startTimer(name) {
  if (!name) {
    console.warn("[sift-perf] timer name required");
    return;
  }
  if (timers.has(name)) {
    console.warn(`[sift-perf] timer "${name}" already running`);
    return;
  }
  timers.set(name, {
    name,
    startedAt: performance.now(),
  });
  console.log(`[sift-perf] ⏱ started: ${name}`);
}

function endTimer(name) {
  if (!name) {
    console.warn("[sift-perf] timer name required");
    return null;
  }
  const timer = timers.get(name);
  if (!timer) {
    console.warn(`[sift-perf] timer "${name}" not found`);
    return null;
  }
  const duration = performance.now() - timer.startedAt;
  timers.delete(name);
  const entry = {
    name,
    duration,
    endedAt: new Date().toISOString(),
  };
  completed.push(entry);
  console.log(`[sift-perf] ✓ ${name}: ${duration.toFixed(2)}ms`);
  return duration;
}

function report() {
  if (completed.length === 0 && timers.size === 0) {
    console.log("[sift-perf] no timers recorded");
    return;
  }
  console.group("[sift-perf] timing report");
  if (completed.length > 0) {
    console.log("completed timers:");
    completed.forEach((entry) => {
      console.log(`  ${entry.name}: ${entry.duration.toFixed(2)}ms`);
    });
    const total = completed.reduce((sum, e) => sum + e.duration, 0);
    console.log(`  total: ${total.toFixed(2)}ms`);
  }
  if (timers.size > 0) {
    console.log("running timers:");
    timers.forEach((timer) => {
      const elapsed = performance.now() - timer.startedAt;
      console.log(`  ${timer.name}: ${elapsed.toFixed(2)}ms (still running)`);
    });
  }
  console.groupEnd();
}

function clear() {
  timers.clear();
  completed.length = 0;
  console.log("[sift-perf] cleared all timers");
}

function measure(name, fn) {
  startTimer(name);
  try {
    const result = fn();
    if (result && typeof result.then === "function") {
      return result.finally(() => endTimer(name));
    }
    endTimer(name);
    return result;
  } catch (error) {
    endTimer(name);
    throw error;
  }
}

export function installPerfTimer() {
  if (typeof window === "undefined") {
    return { startTimer, endTimer, report, clear, measure };
  }
  const api = { startTimer, endTimer, report, clear, measure };
  try {
    window.__siftPerf = api;
  } catch (_) {
    // ignore
  }
  return api;
}
